import React from 'react';
import {BiArrowBack} from 'react-icons/bi';
import {IoMdArrowForward} from 'react-icons/io';

const Pagination = ({totalPages, currentPage, onPageChange}) => {
  const pages = Array?.from({length: totalPages}, (_, i) => i + 1);

  return (
    <div className='flex flex-row items-center justify-between my-6 font-ManropeSemibold '>
      {/* Pages */}
      <div>{`Page ${currentPage} of ${totalPages}`}</div>
      <div className='flex justify-center'>
        <button
          className='px-2 py-1 mx-2 border rounded bg-gray-200 cursor-pointer'
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}>
          <BiArrowBack size={14} />
        </button>
        {pages?.map((page) => (
          <button
            key={page}
            className={`px-3 py-1 mx-1 border rounded ${
              page === currentPage ? 'bg-[#00296B] text-white' : ''
            }`}
            onClick={() => onPageChange(page)}>
            {page}
          </button>
        ))}
        <button
          className='px-2 py-1 mx-2 border rounded bg-gray-200 cursor-pointer'
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}>
          <IoMdArrowForward size={14} />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
